module.exports = __webpack_public_path__ + "img/cst_profile_active.68f7c165.svg";